module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vshou7-4a04708df288d129e7cb7109e3c3daf5.jpg";